import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { painPoints } from '@/mocks/smart-restaurant';

export default function PainPoints() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="客户痛点"
          title="订单、库存、供应与会员，常常各管各的"
          subtitle="从单店到连锁，餐饮经营在规模增长中暴露出更多协同与管理难题。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {painPoints.map((item, idx) => (
            <Reveal key={item.id} delay={idx * 60}>
              <div className="group h-full p-6 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 hover:-translate-y-1 transition-all duration-300">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <div className="mt-4 text-sm font-semibold text-foreground-900">{item.title}</div>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}